export const styles = theme => ({
  root: {
    width: 350,
    padding: 15,
  },
});